<template>
  <BModal
    title="ویرایش نظر تاریخ‌چه جلسات"
    id="edit-comment-in-history"
    centered
    ok-title="ویرایش"
    cancel-title="بستن"
    ok-variant="success"
    no-close-on-backdrop
    no-close-on-ok
    @ok.prevent="updateScheduleHistory"
  >
    <BContainer fluid v-if="scheduleDetails">
      <BFormRow>
        <BCol cols="12">
          <IndependentLessonPicker
            :isMultiple="false"
            :defaultLessonId="scheduleDetails.lessonId"
            :closeOnSelect="true"
            @getLesson="setLesson"
          ></IndependentLessonPicker>
        </BCol>

        <!-- DSD-669 -->

        <!-- <BCol cols="12">
          <QuestionPicker
            inputLabel="انتخاب نمونه سوالاتی که زبان آموز با مشکل مواجه بوده است"
            :selectedLessonId="scheduleDetails.lessonId"
            :defaultSelectedQuestions="scheduleDetails.studentFeedBackQuestions"
            @getQuestions="setQuestions"
          >
          </QuestionPicker>
        </BCol> -->
        <BCol cols="12">
          <CustomEditor
            label="توضیحات جلسه"
            id="desc"
            :hasModules="false"
            v-model="scheduleDetails.description"
          ></CustomEditor>
        </BCol>

        <!-- DSD-669 -->

        <!-- <BCol cols="12">
          <CustomAudioRecorder
            @getAudioFile="setAudioFile"
          ></CustomAudioRecorder>
        </BCol> -->
        <BCol cols="12">
          <small>وضعیت جلسه </small>
          <div
            style="margin-top: 2px"
            class="w-100 d-flex align-items-center justify-content-center"
          >
            <BButton
              :variant="hasPassed ? 'success' : ''"
              class="w-50 mr-1"
              @click="setIsPassedState(true)"
            >
              <FeatherIcon icon="CheckIcon" size="26" />
            </BButton>
            <BButton
              variant="danger"
              class="w-50"
              :variant="hasPassed == false ? 'danger' : ''"
              @click="setIsPassedState(false)"
            >
              <FeatherIcon icon="XIcon" size="26" />
            </BButton>
          </div>
        </BCol>
      </BFormRow>
    </BContainer>
  </BModal>
</template>

<script>
export default {
  emits: ["reFetch"],
  props: {
    defaultScheduleDetails: {
      type: [Object, null],
      required: false,
    },
  },
  watch: {
    defaultScheduleDetails: {
      immediate: true,
      handler(val) {
        if (val) {
          this.scheduleDetails = JSON.parse(JSON.stringify(val));
        }
      },
    },
  },
  data() {
    return {
      scheduleDetails: null,
    };
  },
  methods: {
    async updateScheduleHistory() {
      try {
        this.scheduleDetails["masterStudentLessonViewId"] =
          this.scheduleDetails.id;
        this.isLoading = true;
        let _this = this;
        let tempPayload = { ...this.scheduleDetails };
        delete tempPayload.studentFeedBackQuestions;
        if (tempPayload.questionIds) {
          // tempPayload.questionIds.push(
          //   ...this.scheduleDetails.studentFeedBackQuestions.map(
          //     (item) => item.questionId
          //   )
          // );
        } else {
          tempPayload.questionIds =
            this.scheduleDetails.studentFeedBackQuestions.map(
              (item) => item.questionId
            );
        }
        let updateMasterScheduleLesson = new UpdateMasterScheduleLesson(_this);
        updateMasterScheduleLesson.setFormData(
          helper.generateFormData(tempPayload)
        );
        await updateMasterScheduleLesson.sendFormData((res) => {
          if (res.data.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش شد",
                icon: "CheckIcon",
                variant: "success",
                text: "نظر شما ویرایش شد",
              },
            });
            _this.$emit("reFetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text:
                  res.data.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setQuestions(questions) {
      this.scheduleDetails.questionIds = [];
      if (questions && questions.length) {
        this.scheduleDetails.questionIds = questions.map((item) => {
          return item.questionId;
        });
      }
    },
    setIsPassedState(bool) {
      this.scheduleDetails.isPass = bool;
    },
    setAudioFile(audioFile) {
      this.scheduleDetails.voiceFile = audioFile;
    },
    setLesson(lessonId) {
      this.scheduleDetails.lessonId = lessonId;
    },
  },
  computed: {
    hasPassed() {
      return this.scheduleDetails.isPass;
    },
  },
  components: {
    BModal,
    BContainer,
    BCol,
    BFormRow,
    BFormGroup,
    BFormTextarea,
    BButton,
    IndependentLessonPicker,
    CustomEditor,
    CustomAudioRecorder,
    QuestionPicker,
  },
};
import IndependentLessonPicker from "@/views/components/Lessons/IndependentLessonPicker.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import CustomAudioRecorder from "@/views/components/Utils/CustomAudioRecorder.vue";
import QuestionPicker from "@/views/components/Questions/QuestionPicker.vue";
import CustomEditor from "@/views/components/Utils/CustomEditor.vue";
import helper from "@/libs/Helper";
import {
  BModal,
  BContainer,
  BCol,
  BFormRow,
  BFormGroup,
  BFormTextarea,
  BButton,
} from "bootstrap-vue";
import { UpdateMasterScheduleLesson } from "@/libs/Api/MasterStudentLessonView";
</script>
